import React, { useCallback, useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom";
import GoTaste from "../../assets/icons/Gotaste Logo-20.png";
// import { convertImageToBase64 } from '../../utils/convertToBase64';
import Logo from "../../assets/images/LogoTransparent.png";

const convertImageToBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous"; // Important for handling CORS
    img.src = url;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx: any = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png")); // Convert to Base64
    };

    img.onerror = (err) => reject(err);
  });
};

const QrPdfComponent = ({ scanner, data, componentRef, isTableQr }) => {
  const [baseLogo, setBaseLogo] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  console.log("env urL: ", process.env.REACT_APP_SECRET)
  console.log("env urL: ", process.env.REACT_APP_QR_CODE_URL)

  // const convertToBase64 = useCallback(async ()=>{
  //     if(data?.restaurantLogo){
  //         try {
  //             setLoading(true);
  //             const output = await convertImageToBase64(data?.restaurantLogo);
  //             setLoading(false);
  //             setBase(output);
  //         } catch (error) {
  //             setLoading(false);
  //             console.log(error);
  //         }
  //     }
  // }, [data]);

  const convertToBase64 = useCallback(async () => {
    if (data?.restaurantLogo) {
      try {
        setLoading(true);
        const base64Logo: any = await convertImageToBase64(data.restaurantLogo);
        setBaseLogo(base64Logo); // Set the Base64 image
        setLoading(false);
      } catch (error) {
        console.error("Error converting logo:", error);
        setLoading(false);
      }
    }
  }, [data]);

  // convert to base64
  useEffect(() => {
    convertToBase64();
  }, [convertToBase64]);
  console.log(data, isTableQr);

  return (
    <div className="qr-container" ref={componentRef}>
      <div className="qr-info-container">
        <div>
          <div className="qr-icon">
            <img src={scanner} alt="scan icon" />
          </div>
          <h1 className="qr-title">Scan to order</h1>
          <div className="qr-subtitle">
            Scan this QR code to order your food from the restaurant
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center logo-container">
          <div className="gotaste-logo">
            <img src={Logo} alt="gotaste logo" />
          </div>
          <div className="logo-title">GOTASTE.UK</div>
        </div>

        <div className="Qr-code">
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
          <div className="line4"></div>
          <div className="Qr-container">
            {isTableQr ? (
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={`${process.env.REACT_APP_QR_CODE_URL}/table-selection/${data?.tableId}/${data?.restaurantId}`}
                viewBox={`0 0 256 256`}
                level="Q"
              />
            ) : (
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={`${process.env.REACT_APP_QR_CODE_URL}/${data?.urlName}`}
                viewBox={`0 0 256 256`}
                level="H"
              />
            )}

            <div
              className={`qr-table-number ${isTableQr ? "" : "qr-table-small"}`}
            >
              <div className="qr-logo">
                <img src={GoTaste} alt="logo" />
              </div>
              <span className="qr-num">{isTableQr ? data?.tableName : ""}</span>
              <Link
                className="restaurant-url"
                to={
                  isTableQr
                    ? `${process.env.REACT_APP_QR_CODE_URL}/${data?.restaurantURL}`
                    : `${process.env.REACT_APP_QR_CODE_URL}/${data?.urlName}`
                }
                target="_blank"
              >
                gotaste.uk/{isTableQr ? data?.restaurantURL : data?.urlName}
              </Link>
            </div>
          </div>
        </div>

        <div className="qr-footer">
          <div className="restaurant-info-container">
            <div className="restaurant-logo">
              <img
                // src={isTableQr ? data?.restaurantLogo : data?.logoUrl}
                src={
                  baseLogo || (isTableQr ? data.restaurantLogo : data.logoUrl)
                }
                alt={"restaurant logo"}
              />
            </div>

            <h2 className="qr-restaurant">
              {isTableQr ? data?.restaurantName : data?.name}
            </h2>
          </div>
          <div className="qr-created">
            Created by GoTaste:
            <span className="qr-link">
              {" "}
              gotaste.uk/{isTableQr ? data?.restaurantURL : data?.urlName}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrPdfComponent;
